export default "__VITE_ASSET__C7nwglI7__"